<template>
  <div class="account-setup-container">
    <div >
      <v-progress-linear :active="loading" :indeterminate="loading" color="#FF6D44" />
      <div class="account-setup-card">
        <img src="@/assets/logo.png" alt="MENDMate Logo" class="logo" />
        <h1 class="app-name">MENDmate</h1>
        <p class="subtitle">Create your account</p>

        <div class="account-setup-form">
          <!-- Row 1: First Name & Last Name -->
          <div class="form-row">
            <div class="input-group">
              <label for="firstName">First Name</label>
              <input type="text" id="firstName" v-model="firstName" placeholder="Enter your first name"
                class="input-field" />
            </div>

            <div class="input-group">
              <label for="lastName">Last Name</label>
              <input type="text" id="lastName" v-model="lastName" placeholder="Enter your last name"
                class="input-field" />
            </div>
          </div>

          <!-- Row 2: Email & Phone Number -->
          <div class="form-row">
            <div class="input-group">
              <label for="email">Email</label>
              <input type="email" id="email" v-model="email" placeholder="Enter your email address"
                class="input-field" />
            </div>

            <div class="input-group">
              <label for="phone">Phone Number</label>
              <input type="tel" id="phone" v-model="phone" placeholder="Enter your phone number" class="input-field" />
            </div>
          </div>

          <!-- Row 3: Password & Confirm Password -->
          <div class="form-row">
            <div class="input-group">
              <label for="password">Password</label>
              <input type="password" id="password" v-model="password" placeholder="Create a password"
                class="input-field" />
              <p class="password-hint">
                Your password must contain at least 12 characters, one lowercase,
                one uppercase, and one special character.
              </p>
            </div>

            <div class="input-group">
              <label for="confirmPassword">Confirm Password</label>
              <input type="password" id="confirmPassword" v-model="confirmPassword" placeholder="Re-enter your password"
                class="input-field" />
            </div>
          </div>

          <!-- Row 4: Role & Provider's Code -->
          <div class="form-row">
            <div class="input-group">
              <label for="role">Are you a provider or a patient?</label>
              <select v-model="role" id="role" class="input-field">
                <option value="Patient">Patient</option>
                <option value="Provider">Provider</option>
              </select>
            </div>

            <div v-show="isPatient" class="input-group">
              <label for="providerCode">Provider's Code</label>
              <input type="text" id="providerCode" v-model="providerCode" placeholder="Enter connection code"
                class="input-field" />
            </div>
          </div>

          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

          <!-- Register Button -->
          <button class="register-btn" @click="register" :disabled="loading">Register</button>
        </div>
        <p class="signup-link">
          Already have an account? <a href="#" @click="goToLogin">Sign in.</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      password: '',
      confirmPassword: '',
      role: 'Patient',
      providerCode: '',
      errorMessage: null,
      loading: false,
    };
  },
  computed: {
    isPatient() {
      return this.role === "Patient";
    }
  },
  methods: {
    async register() {
      // Handle registration logic here
      this.loading = true;
      this.errorMessage = null;
      this.providerCode = this.providerCode.trim();
      try {
        axios.defaults.baseURL = process.env.VUE_APP_API_URL;
        let postUrl = "";

        if (this.providerCode.length > 0) {
          postUrl = "api/auth/validate-provider-code";
          let response = await axios.post(postUrl, { providerCode: this.providerCode })
          if (response.data === false) {
            this.loading = false;
            this.errorMessage = "Provider Code is not valid.";
            return;
          } else {
            this.errorMessage = null;
          }

        }

        postUrl = "api/auth/register?role=" + this.role;
        await axios.post(postUrl, {
          firstName: this.firstName,
          lastName: this.lastName,
          username: this.email,
          password: this.password,
          email: this.email,
          providerCode: (this.providerCode.length > 0) ? this.providerCode : null,
        }
        );
        this.loading = false;
        this.$router.push({ name: 'LoginPage' });
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.errorMessage = "Registration failed. Please check your information.";
      }
    },
    goToLogin() {
      this.$router.push({ name: 'LoginPage' });
    }
  },
};
</script>

<style scoped>
* {
  font-family: 'Montserrat', sans-serif;
}

.account-setup-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #08B6AA;
  overflow-y: auto
}

.account-setup-card {
  background-color: #ffffff;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  /* Limit max width for larger screens */
  max-height: 90vh;
  /* Limit height to 90% of viewport */
  overflow-y: auto;
  /* Enable scrolling within the card if needed */
}

.logo {
  width: 80px;
  margin-bottom: 0.2rem;
}

.app-name {
  font-size: 30px;
  color: #08B6AA;
  margin: 0;
}

.subtitle {
  margin: 0.5rem 0 1.5rem;
  font-size: 14px;
  color: #4A4A4A;
}

.account-setup-form {
  margin-top: 1rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.input-group {
  flex: 1;
  text-align: left;
}

.input-group label {
  display: block;
  margin-bottom: 0.3rem;
  font-size: 14px;
  color: #4A4A4A;
  font-weight: bold;
}

.input-field {
  width: 100%;
  padding: 0.5rem;
  font-size: 14px;
  border: 1px solid #DADADA;
  border-radius: 4px;
}

.input-field::placeholder {
  font-size: 10px;
}

.password-hint {
  font-size: 10px;
  color: #8a8a8a;
  margin-top: 0.2rem;
}

.register-btn {
  width: 100%;
  padding: 0.5rem;
  background-color: #FF6D44;
  color: #fff;
  font-size: 16px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  margin-top: 1rem;
}

.register-btn:hover {
  background-color: #e64a19;
}

.register-btn:disabled {
  background-color: #293840;
}

.signup-link {
  margin-top: 1rem;
  font-size: 14px;
  color: #4A4A4A;
}

.signup-link a {
  color: #FF5722;
  text-decoration: none;
}

.signup-link a:hover {
  text-decoration: underline;
}

/* error message */
.error-message {
  color: #FF5722;
  font-size: 14px;
  margin: 0.5rem 0;
  font-weight: bold;
}
</style>